"use client";

import { useState } from "react";

// Simple Collapsible Component
const Collapsible = ({ children, className = "" }) => {
  return <div className={`collapsible ${className}`}>{children}</div>;
};

// Collapsible Trigger Component
const CollapsibleTrigger = ({ children, onClick, className = "" }) => {
  return (
    <button
      type="button"
      className={`collapsible-trigger w-full text-left ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

// Collapsible Content Component
const CollapsibleContent = ({ children, isOpen, className = "" }) => {
  return (
    <div
      className={`collapsible-content overflow-hidden transition-all duration-300 ease-in-out ${
        isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
      } ${className}`}
    >
      <div className="p-4">{children}</div>
    </div>
  );
};

// Complete Collapsible Component with state management
const CollapsibleSection = ({
  trigger,
  children,
  defaultOpen = false,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Collapsible className={className}>
      <CollapsibleTrigger
        onClick={toggleCollapsible}
        className="bg-white text-[#171717]"
      >
        {typeof trigger === "function" ? trigger(isOpen) : trigger}
      </CollapsibleTrigger>
      <CollapsibleContent isOpen={isOpen}>{children}</CollapsibleContent>
    </Collapsible>
  );
};

// Export all components
export {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
  CollapsibleSection,
};
// Also export CollapsibleSection as default for convenience
export default CollapsibleSection;
